<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="单位名称">
              <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="联系人姓名">
              <a-input v-model="queryParam.name" placeholder="搜索联系人姓名"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="审核">
              <a-select v-model="queryParam.sstatus" placeholder="请选择"
                        allowClear>
                <a-select-option value="2">等待审核</a-select-option>
                <a-select-option value="1">审核成功</a-select-option>
                <a-select-option value="3">审核失败</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <template v-if="advanced && false">
            <a-col :md="6" :sm="24">
              <a-form-item label="负责人姓名">
                <a-input v-model="queryParam.nickname" placeholder="搜索负责人姓名"/>
              </a-form-item>
            </a-col>


            <a-col :md="6" :sm="24">
              <a-form-item label="申报时间">
                <a-range-picker
                    v-model="time_range_moment"
                    style="width: 100%"
                    format="YYYY-MM-DD HH:mm:ss"
                    :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons"
                  :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
<!--      <a-button @click="download(2)" style="margin-left: 8px">-->
<!--        申报批次导出表-->
<!--        <a-icon type="download"/>-->
<!--      </a-button>-->

      <a-dropdown v-if="  selectedRowKeys.length > 0 && false">
        <a-menu slot="overlay">
          <a-menu-item @click="onCenterDeleteAll" key="1">
            <a-icon type="delete"/>
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down"/>
        </a-button>
      </a-dropdown>
    </div>

    <s-table
        ref="table"
        size="default"
        :columns="columns"
        :data="loadData"
        :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="danwei" slot-scope="text,record">
          <div style="float: left">
            {{ record.danwei }}

            <br/><span style="color: #999">{{ record.province }}{{ record.city }}{{ record.county }}</span>
            <br/>
            联系人:{{ record.name }} <span style="color: #999">手机:{{ record.phone }}</span>

          </div>
      </span>

      <span slot="type" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            <a-tag v-if="record.kaojitype=='考级点'" color="green">
              考级点
            </a-tag>
            <a-tag v-else color="blue">
              考级中心
            </a-tag>

          </div>
      </span>
      <span slot="price" slot-scope="text,record">
          <a-tag v-if="record.kaoji_jiameng_type==1">老政策</a-tag>
            <a-tag v-else-if="record.kaoji_jiameng_type==2">0元</a-tag>
            <a-tag v-else-if="record.kaoji_jiameng_type==3">9800元</a-tag>
            <a-tag v-else-if="record.kaoji_jiameng_type==4">12万元</a-tag>
            <a-tag v-else-if="record.kaoji_jiameng_type==5">13.5万元</a-tag>
            <a-tag v-else>未知</a-tag>
      </span>
      <span slot="jinqun" slot-scope="text,record">
          {{ record.is_jinqun == 1 ? '是' : '否' }}
      </span>
      <span slot="fahuo" slot-scope="text,record">
          {{ record.is_fahuo == 1 ? '已发' : '未发' }}
      </span>
      <span slot="code" slot-scope="text,record">
            {{ record.kaojiregist_code ? record.kaojiregist_code : '(无)' }}
            <br/>
            申请时间 {{ record.create_time|timeFormat }}
            <br/>
        <span v-if="record.recommend_name">推荐加盟人：{{ record.recommend_name }}</span>

      </span>
      <span slot="jindu" slot-scope="text,record">
        <a-tag v-if="record.kaoji_jindu">{{ record.kaoji_jindu|jinduFilter }}</a-tag>

        <a-tag v-if="record.kaojiregist_status==1" color="red">等待审核</a-tag>
        <a-tag v-else-if="record.kaojiregist_status==2" color="green">审核成功</a-tag>
        <a-tag v-else-if="record.kaojiregist_status==3" color="purple">审核失败</a-tag>
        <a-tag v-else-if="record.kaojiregist_status==4" color="blue">预审核</a-tag>
        <a-tag v-else>未提交</a-tag>
      </span>
      <span slot="action" slot-scope="text,record">
        <template>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical"/>
          <a @click="handleDownload(record)">下载申报表</a>
<!--          <a-divider type="vertical"/>-->
<!--          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="deleteHandle(record)" okText="确定" cancelText="取消">-->
<!--            <a href="javascript:;">删除</a>-->
<!--          </a-popconfirm>-->
        </template>
      </span>
    </s-table>

    <a-modal
        :maskClosable="false"
        title="操作"
        :width="1200"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="visible"
        @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="年份"
                  hasFeedback
              >
                <a-select v-model="formData.year" placeholder="请选择"
                >
                  <a-select-option value="2021">2021</a-select-option>
                  <a-select-option value="2020">2020</a-select-option>
                  <a-select-option value="2019">2019</a-select-option>
                  <a-select-option value="2018">2018</a-select-option>
                  <a-select-option value="2017">2017</a-select-option>
                  <a-select-option value="2016">2016</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="省市"
                  hasFeedback
              >
                <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="formData.namekeys" changeOnSelect
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="单位"
                  hasFeedback
              >
                <a-input v-decorator="[
          'danwei',
          {rules: [{ required: true, message: '请输入单位' }]}
        ]"
                         placeholder="请输入单位"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="邮寄地址"
                  hasFeedback
              >
                <a-input v-decorator="[
          'address',
          {rules: [{ required: true, message: '请输入邮寄地址' }]}
        ]"
                         placeholder="请输入邮寄地址"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  label="身份证照片"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
              >
                <pic-uploader
                    :file-list="formData.shenfenzheng_pic"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-divider>联系人信息</a-divider>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="联系人姓名"
                  hasFeedback
              >
                <a-input v-decorator="[
          'name',
          {rules: [{ required: true, message: '请输入联系人姓名' }]}
        ]"
                         placeholder="请输入联系人姓名"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="联系人手机"
                  hasFeedback
              >
                <a-input v-decorator="[
          'phone',
          {rules: [{ required: true, message: '请输入联系人手机' }]}
        ]"
                         placeholder="请输入联系人手机"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="联系人邮箱"
                  hasFeedback
              >
                <a-input v-decorator="[
                    'email',
                    {rules: [{ required: true, message: '请输入联系人邮箱' }]}
                  ]"
                         placeholder="请输入联系人邮箱"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="联系人微信"
                  hasFeedback
              >
                <a-input v-decorator="[
          'weixin',
          {rules: [{ required: true, message: '请输入联系人微信' }]}
        ]"
                         placeholder="请输入联系人微信"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-divider>审核信息</a-divider>
          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
              <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="省级审核状态"
                  hasFeedback
              >
                <a-radio-group v-model="formData.sstatus" buttonStyle="solid">
                  <a-radio-button :value="2">待审核</a-radio-button>
                  <a-radio-button :value="1">审核通过</a-radio-button>
                  <a-radio-button :value="3">审核失败</a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>

<!--          <a-row :gutter="48">-->
<!--            <a-col :md="48" :sm="24">-->
<!--              <a-form-item-->
<!--                  :labelCol="{-->
<!--          xs: { span: 12 },-->
<!--          sm: { span: 4 }}"-->
<!--                  :wrapperCol="{-->
<!--          xs: { span: 24 },-->
<!--          sm: { span: 12 }}"-->
<!--                  label="审核状态"-->
<!--                  hasFeedback-->
<!--              >-->
<!--                <a-radio-group v-model="formData.status" buttonStyle="solid">-->
<!--                  <a-radio-button :value="2">待审核</a-radio-button>-->
<!--                  <a-radio-button :value="1">审核通过</a-radio-button>-->
<!--                  <a-radio-button :value="3">审核失败</a-radio-button>-->
<!--                </a-radio-group>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--          </a-row>-->

        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>

  </a-card>
</template>

<script>
import STable from '@/components/table/'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
import EditableCell from '@/components/EditableCell/'
import RSwitch from '@/components/RSwitch/'
import PicUploader from '@/components/PicUploader/'
import FileUploader from '@/components/FileUploader/'
import areaOptions from '@/utils/area'
import moment from 'moment'
import 'moment/locale/zh-cn';

moment.locale('zh-cn');

import {
  getLevelApplyList,
  getLevelApplyDetail,
  editLevelApply,
  deleteLevelApply,
  getCenterDownloadUrl
} from '@/api/yundongyuan'
import setting from "@/config/setting";

export default {
  name: 'LevelApplyList',
  components: {
    AInput,
    ATextarea,
    FileUploader,
    PicUploader,
    STable,
    RSwitch,
    EditableCell,
  },
  data() {
    return {
      areaOptions,
      visible: false,
      saveLoading: false,
      formData: {
        id: 0,
        year: '', name: '', danwei: '', namekey: '', province: '', city: '', county: '', shenfenzheng_pic: [],
        phone: '', weixin: '', email: '', address: '', yundongyuan: []
      },
      buyGoodsOptions: [
        {
          "label": "1 标准肋木",
          "value": 1
        },
        {
          "label": "2 标准把杆（固定/移动）",
          "value": 2
        },
        {
          "label": "3 斜坡啦啦操垫（翻滚）",
          "value": 4
        },
        {
          "label": "4 啦啦操训练垫",
          "value": 8
        },
        {
          "label": "5 柔韧测试器（髋部）",
          "value": 16
        },
        {
          "label": "6 积木式跳箱",
          "value": 32
        },
        {
          "label": "7 柔韧测试器（肩部）",
          "value": 64
        },
        {
          "label": "8 啦啦操翻腾训练辅助器（组合）A",
          "value": 128
        },
        {
          "label": "9 啦啦操翻腾训练辅助器（组合）B",
          "value": 256
        },
        {
          "label": "10 七彩星级专用训练考试地胶",
          "value": 512
        },
        {
          "label": "11 啦啦操方形蹦床",
          "value": 1024
        },
        {
          "label": "12啦啦操专用平衡器",
          "value": 2048
        }
      ],
      time_range_moment: [],
      time_range: [],
      labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
        xs: {span: 24},
        sm: {span: 8},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 12},
      },
      form: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: '',
      },
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '单位信息',
          dataIndex: 'danwei',
          scopedSlots: {customRender: 'danwei'},
        },
        {
          title: '申报数量',
          dataIndex: 'count',
        },
        {
          title: '申报时间',
          dataIndex: 'create_time',
          customRender: (text) => {
            return moment(text * 1000).format('YYYY-MM-DD HH:mm:ss')
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 200,
          scopedSlots: {customRender: 'action'},
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData');
        console.log(this.queryParam);
        let that = this;

        if (this.time_range_moment[0] && this.time_range_moment[1]) {
          this.queryParam.time_range = [
            this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
            this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
          ]
        } else {
          this.queryParam.time_range = []
        }

        // this.queryParam.namekeys = []
        // this.queryParam.danwei = ''
        // this.queryParam.kaoji_jiameng_type = ''
        // this.queryParam.kaojiregist_status = 0
        this.queryParam = Object.assign(this.queryParam, parameter);

        console.log(this.queryParam)
        return getLevelApplyList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
      },

      selectedRowKeys: [],
      selectedRows: [],
      cashFormData: {
        ids: [],
        to_type: '',
        price: 0,
        note: '',
        count: 0,
      }
    }
  },
  computed: {},
  created() {
  },

  mounted() {
    let that = this;
  },
  methods: {
    moment,
    handleCancel() {
      this.visible = false
    },
    //展开关闭
    toggleAdvanced() {
      this.advanced = !this.advanced
    },

    handleDownload(record) {
      window.open(setting.apiBaseURL + '/' + record.zipsrc)
    },
    handleEdit(record) {
      let self = this
      this.visible = true
      getLevelApplyDetail({id: record.id}).then(res => {
        setTimeout(() => {
          self.form.setFieldsValue({...res.data})
          self.formData.id = record.id;
          console.log('handleEdit')

          res.data.namekeys = [res.data.namekey.substring(0, 2) + '0000', res.data.namekey.substring(0, 4) + '00', res.data.namekey];
          if (res.data.area) {
            res.data.areas = [res.data.area.substring(0, 2) + '0000', res.data.area.substring(0, 4) + '00', res.data.area];
          } else {
            res.data.areas = [];
          }
          self.formData = {...res.data};
        }, 200)
      })
    },

    deleteHandle(record) {
      let self = this
      deleteLevelApply({id: record.id}).then(res => {
        self.$message.success('删除成功')
        self.$refs.table.refresh(false)
      }).catch(err => {
        self.$message.error(err.data.msg)
      })
    },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },

    onCenterDeleteAll() {
      let self = this
      centerDeleteAll({ids: this.selectedRowKeys}).then(res => {
        self.$message.success('删除成功')
        self.$refs.table.refresh(false)
      }).catch(err => {
        self.$message.error(err.data.msg)
      })
    },

    // 增改 处理
    handleOk(e) {
      let self = this;
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.formData)
           // province: '', city: '', county: ''

          self.saveLoading = true;
          editLevelApply({
            id: self.formData.id,
            namekey: self.formData.namekeys[self.formData.namekeys.length - 1],
            danwei: values.danwei,
            address: values.address,
            year: self.formData.year,
            shenfenzheng_pic: self.formData.shenfenzheng_pic,
            email: values.email,
            phone: values.phone,
            weixin: values.weixin,
            name: values.name,
            status: self.formData.status,
            sstatus: self.formData.sstatus,
          }).then(res => {
            self.$message.success('修改成功')
            self.$refs.table.refresh(false)
            self.visible = false;
            self.saveLoading = false;
          }).catch(err => {
            self.$message.error(err.data.msg);
            self.saveLoading = false;
          })
        }
      })
    },

    download(type) {
      // return
      let params = Object.assign(this.queryParam, {time_range: this.time_range_moment, type: type})
      // console.log('params', params);return
      getCenterDownloadUrl(params)
          .then(res => {
            console.log(res)
            window.open(res.data)
          })
          .catch(err => {
            this.$message.error(err.data.msg)
          })
      return;
      switch (type) {
        case 1:
          // 地区信息表
          window.open(setting.apiBaseURL + '/adminapi/examecenter/centerDownload?saiqu=');
          break;
        case 2:
          // console.log(this.queryParam)
          //   return
          break;
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

  },
  filters: {
    jinduFilter(value) {
      switch (value) {
        case 1:
          return `联系申报单位`;
        case 2:
          return `告知省级委员会并征求意见+申报单位积极准备中`;
        case 3:
          return `申报单位积极准备中`;
        case 4:
          return `条件已具备，等待验收`;
        case 5:
          return `等待全国啦啦操委员会验收`;
        case 6:
          return `验收并授牌`;
        case 7:
          return `同意考试`;
      }
    },
  },
  watch: {}
}
</script>
